import { styled, Switch } from "@mui/material";

export const GreenSwitch = styled(Switch)(({ theme }) => ({
  width: 31,
  height: 18,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    marginTop: "1.5px",
    marginLeft: "2px",
    color: "#9e9e9e",
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#4caf50",
      "& + .MuiSwitch-track": {
        backgroundColor: "transparent",
        border: "2px solid #4caf50",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 12,
    height: 12,
    margin: "1px",
  },
  "& .MuiSwitch-track": {
    borderRadius: 20,
    border: "2px solid #9e9e9e",
    backgroundColor: "transparent",
    opacity: 1,
    transition: theme.transitions.create(["border-color", "background-color"], {
      duration: 300,
    }),
  },
}));
